module.exports = __webpack_public_path__ + "img/dg16.38e007ba.png";